const e=/^[0-9]+$/,t=(t,r)=>{const s=e.test(t),i=e.test(r);return s&&i&&(t=+t,r=+r),t===r?0:s&&!i?-1:i&&!s?1:t<r?-1:1};var r={compareIdentifiers:t,rcompareIdentifiers:(e,r)=>t(r,e)};export{r as i};
